import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'pink-lava-ui/index.css';
import './index.css';
import App from './App.js';
import * as Sentry from "@sentry/react";

const sentryEnvironment =
  import.meta.env.VITE_VENDOR_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'development';

Sentry.init({
  dsn: import.meta.env.VITE_VENDOR_SENTRY_DSN,
  environment: sentryEnvironment,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});


createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
